// @flow
import React from 'react'
import createReactClass from 'create-react-class'
import i18n from 'live/services/i18n'
import FormGroup from 'live/components/forms/ui/form-group'
import ActionToggle from 'live/components/ui/action-toggle'
import styled from 'styled-components'
import {
    encryptDidMount,
    handleEncryptSubmit
} from 'live/components/forms/ui/UserTable/utils'
import EncryptForm from 'live/components/forms/ui/UserTable/EncryptForm'
import PasswordInput from 'live/components/forms/ui/UserTable/PasswordInput'

var ValidationMixin = require('live/components/forms/mixins/validation-mixin'),
    ObjectInitializerMixin = require('live/components/forms/mixins/object-initializer')('/rest/extension', {
        type: 'liverig-pocoweb-wellimport',
        active: true,
        config: {
            id: null,
            enableForInput: true,
            uri: '',
            username: '',
            trust: false,
            enableCsb: false
        },
        fullQualifier: '',
        qualifier: '',
        status: {}
    }),
    FormBase = require('live/components/extensions/ui/form')

// eslint-disable-next-line react/display-name
module.exports = createReactClass({
    mixins: [ObjectInitializerMixin, ValidationMixin],
    validations: {
        properties: {
            config: {
                properties: {
                    uri: {
                        required: true,
                        allowEmpty: false,
                        message: i18n('URL') + ' ' + i18n('must not be empty')
                    },
                    username: {
                        required: true,
                        allowEmpty: false,
                        message: i18n('Username') + ' ' + i18n('must not be empty')
                    },
                    password: {
                        required: true,
                        allowEmpty: false,
                        message: i18n('Password') + ' ' + i18n('must not be empty')
                    },
                    trust: {
                        required: false,
                        allowEmpty: true
                    },
                    id: {
                        required: false,
                        allowEmpty: true
                    }
                }
            }
        }
    },
    _onSuccess: function () {
        window.location.href = '#/integrations/' + this.state.object.type + '/' + this.state.object.id
    },
    _onDelete: function () {
        console.log(this.state.object)
        window.location.href = '#/integrations/'
    },
    onChangeInfo(data, key) {
        let { object } = this.state
        let config = object.config

        config[key] = data
        this.applyObj({ config: config })
    },
    componentDidMount() {
        encryptDidMount.bind(this)()
    },
    render: function () {
        let object = this.state.object

        let config = object.config
        handleEncryptSubmit.bind(this)()

        return (
            <EncryptForm self={this} uiCfg={{ hideDivider: false, disableRoles: true }}>
                <div className="form-area extensionWellImport">
                    <div className="row">
                        <div className="col-md-12">
                            <FormGroup
                                type="text"
                                label={i18n('URI')}
                                name="config.uri"
                                value={config.uri}
                                onChange={this.handleValidation}
                                validationState={this.validationState('config.uri')}
                                hasFeedback
                                help={this.errorsFor('config.uri')}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <FormGroup
                                type="text"
                                label={i18n('ClientId')}
                                name="config.username"
                                value={config.username}
                                onChange={this.handleValidation}
                                validationState={this.validationState('config.username')}
                                hasFeedback
                                help={this.errorsFor('config.username')}
                            />
                        </div>
                        <div className="col-md-6">
                            <PasswordInput
                                label={i18n('Client Secret')}
                                id={`${object?.type}/${object?.qualifier || ''}`}
                                name="config.password"
                                initPassword={this.state.original?.config?.password}
                                onChange={newPassword => {
                                    this.handleValidation({
                                        target: {
                                            name: 'config.password',
                                            value: newPassword
                                        }
                                    })
                                }}
                                hasFeedback
                                help={this.errorsFor('config.password')}
                                setEditing={this.state.setHasUnSavedPassword}
                            />
                        </div>
                        <ToggleConfig className="col-md-6">
                            <StyledToogle>
                                <ActionToggle
                                    name="trust"
                                    onChange={(event) => this.onChangeInfo(!config.trust, 'trust')}
                                    active={config.trust}
                                />
                                <label>{i18n('TrustCertificate')}</label>
                            </StyledToogle>
                            <StyledToogle>
                                <ActionToggle
                                    name="enableCsb"
                                    onChange={(event) => this.onChangeInfo(!config.enableCsb, 'enableCsb')}
                                    active={config.enableCsb}
                                />
                                <label>{i18n('CSB schematic')}</label>
                            </StyledToogle>
                        </ToggleConfig>
                    </div>
                </div>
            </EncryptForm>
        )
    }
})
const ToggleConfig = styled.div`
    margin-bottom:30px;
`
const StyledToogle = styled.div`
    display: flex;
    margin-bottom: 15px;
    label {
        margin-top: 7px;
    }
    .action-toggle {
        z-index: 0;
    }
`